import React from "react";
import { User, GoalOption, lowCarbonGoalOptions } from "@ecologi/shared";

import styles from "../styles/AddNewItem.module.scss";
import classNames from "classnames";

export type AddNewItemProps = {
  user: User;
  onAddChecklistItem: (
    user: User,
    goalOption: GoalOption,
    cb?: () => void
  ) => void;
};

export const AddNewItem = ({ user, onAddChecklistItem }: AddNewItemProps) => {
  const checklistItems = user.checklistItems || [];
  const nonSelectedGoals = lowCarbonGoalOptions.filter(
    (o) => !checklistItems.map((c) => c.text).includes(o.label)
  );

  const isFirstGoal = checklistItems.length === 0;

  return (
    <div
      className={classNames(styles.addNewItem, {
        [styles.addNewItemEmptyList]: isFirstGoal,
      })}
    >
      <div className={styles.addNewItemSelect}>
        <label htmlFor="goal-select" aria-label="Select the goal"></label>
        <select
          id="goal-select"
          aria-label="Select the goal"
          data-testid="goal-select"
          value={0} // Always show the first option (Add new)
          onChange={async (e) => {
            e.preventDefault();

            // Find the option for this value
            const goalOption = lowCarbonGoalOptions.find(
              (o) => o.value === e.currentTarget.value
            );

            if (goalOption) {
              onAddChecklistItem(user, goalOption);
            }
          }}
        >
          <option value={0}>
            {isFirstGoal ? "Add your first goal" : "Add another goal"}
          </option>
          {nonSelectedGoals.map((goal) => (
            <option key={goal.value} value={goal.value}>
              {goal.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
